import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-135e2360"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view add-moderator" }
const _hoisted_2 = { class: "add-moderator__header" }
const _hoisted_3 = { class: "add-moderator__header-left" }
const _hoisted_4 = { class: "add-moderator__title" }
const _hoisted_5 = { class: "add-moderator__header-right" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons left" }, "mail", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Resend invitation")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons left" }, "mail", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Reset password")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons left" }, "loop", -1))
const _hoisted_13 = { class: "add-moderator__form-panel" }
const _hoisted_14 = { class: "add-moderator__form-section" }
const _hoisted_15 = { class: "add-moderator__form-box" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "add-moderator__headline" }, "Informations", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "First name", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "add-moderator__bot-buttons" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "button button--big button--green" }, "Save Changes")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.moderator.email), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button button--yellow",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resendInvitation && _ctx.resendInvitation(...args)), ["prevent"]))
            }, _hoisted_8))
          : _createCommentVNode("", true),
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "button button--yellow",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args)), ["prevent"]))
            }, _hoisted_11))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "button button--yellow",
          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.setModStatus && _ctx.setModStatus(...args)), ["prevent"]))
        }, [
          _hoisted_12,
          _createTextVNode(" " + _toDisplayString(_ctx.statusBtnLabel) + " moderator", 1)
        ])
      ])
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _hoisted_17,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "email",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.moderator.email) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.moderator.email]
            ]),
            _hoisted_18,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "name",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.moderator.name) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.moderator.name]
            ])
          ])
        ])
      ]),
      _hoisted_19
    ], 32)
  ]))
}